import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class FulfillmentStatusMultiSelectListComponent implements IController {
  fulfillmentDisplayStatus: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor(private FulfillmentConstants) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.FulfillmentConstants.fulfillmentDisplayStatuses;
    }
  }

  $onChanges(changes) {
    if (changes.fulfillmentDisplayStatus) {
      this.selectedKeys = [];
      _.forEach(this.fulfillmentDisplayStatus, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      fulfillmentDisplayStatus: isSelected ? _.concat(this.fulfillmentDisplayStatus, [option]) :
        _.filter(this.fulfillmentDisplayStatus, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({fulfillmentDisplayStatus: []});
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStatusMultiSelectList', {
    bindings: {
      fulfillmentDisplayStatus: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./fulfillment-status-multi-select-list.html').default,
    controller: FulfillmentStatusMultiSelectListComponent
  });


